import Modal from "../../UI/Modal";
import useCustomerServiceWeek from "../../../hooks/useCustomerServiceWeek";

const CustomerServiceWeek = () => {
  const {
    show,
    close,
    dontShowAgain,
    setDontShowAgain,
    isWithinWeek,
  } = useCustomerServiceWeek();

  // Do not render at all if we are not in CS Week window
  if (!isWithinWeek) return null;

  return (
    <Modal
      openStatus={show}
      closeFunc={close}
      panelStyles="h-90vh relative mx-auto w-[92%] overflow-hidden rounded-[20px] bg-[#171629] text-white outline-none md:w-[70%] xl:max-w-[820px]"
    >
      {/* Top flags/banners */}
      <div className="pointer-events-none absolute inset-x-0 top-0 z-10">
        <div className="relative aspect-[140/120] h-[120px] w-full">
          <img
            src="/festive-flag.png"
            alt="bunting"
            className="absolute inset-0 h-full w-full object-cover"
          />
        </div>
      </div>

      {/* Content */}
      <div className="pb- flex h-full w-full flex-col items-center justify-center gap-6 px-6 pt-40 md:px-12">
        <div className="text-center">
          <h1 className="text-3xl font-semibold sm:text-4xl md:text-5xl">
            🎉 Happy Customer
          </h1>
          <h2 className="mt-1 text-3xl font-semibold sm:text-4xl md:text-5xl">
            Service Week! ⭐
          </h2>
        </div>

        <div className="mx-auto max-w-[640px] text-center text-base leading-7 text-[#EDEBF7] md:text-lg">
          <p>
            At Reach Cinemas, YOU are the star of the show! Thank you for
            choosing us and making every experience unforgettable.
          </p>
          <p className="mt-3">
            Here’s to more laughter, thrills, and movie moments together! 🍿🎬
          </p>
        </div>

        {/* Actions */}
        <div className="mt-2 flex flex-col items-center gap-3">
          <button
            onClick={() => close(dontShowAgain)}
            className="w-[160px] rounded-md bg-gradient-to-r from-[#6E35FF] to-[#7F4DFF] px-4 py-3 text-center text-white shadow-lg"
          >
            Close
          </button>
          <label className="flex cursor-pointer items-center gap-2 text-sm text-[#EDEBF7]">
            <input
              type="checkbox"
              checked={dontShowAgain}
              onChange={(e) => setDontShowAgain(e.target.checked)}
              className="h-4 w-4 accent-[#7F4DFF]"
            />
            <span>do not show this again</span>
          </label>
        </div>

        {/* Footer URL (optional) */}
        {/* <p className="absolute bottom-4 left-1/2 flex -translate-x-1/2 items-center gap-1 font-red-hat text-sm italic text-[#EDEBF7]">
            <img src="/star.png" alt="star" width={10} height={10} />
            www.reachcinema.io
          </p> */}

        {/* Decorative assets - previous inline implementation */}
        <div className="flex w-full items-center justify-center">
          <div className="relative aspect-[140/140] h-[100px] max-w-[140px] sm:h-[140px]">
            <img
              src="/awardservice.png"
              alt="trophy"
              className="pointer-events-none absolute inset-0 h-full w-full object-cover"
            />
          </div>
        </div>
      </div>
    </Modal>
  );
};

export default CustomerServiceWeek;
